// extracted by mini-css-extract-plugin
export default {"skeleton-brick":"VUjRq","skeleton-animation":"eZJgD","skeleton-circle":"EN2eJ"};